
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/community_guide",
      function () {
        return require("private-next-pages/community_guide.page.tsx");
      }
    ]);
  